// Styling for Buy It Now button
const style = document.createElement("style");
style.innerHTML = `
    .buy-it-now-button {
        background-color: #F8BE00 !important;
        color: #000 !important;
        padding: 14px 24px !important;
        font-size: 18px !important;
        border: none !important;
        cursor: pointer !important;
        margin-left: 10px !important;
        text-align: center !important;
        border-radius: 8px !important;
        display: inline-block !important;
        width: 49% !important;
    }

    @media screen and (max-width: 768px) {
        .buy-it-now-button {
            width: 48% !important;
        }
    }

    .buy-it-now-button:hover {
        background-color: #A3483C !important;
    }
`;
document.head.appendChild(style);


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        let addToCartBtn = document.querySelector("form[action*='/cart/add'] button[type='submit']");
        let quantityInput = document.querySelector("input[id^='Quantity']") || document.querySelector("input[name='quantity']");
        let variantInput = document.querySelector("input[name='id']"); // current product variant ID
        let priceMeta = document.querySelector(".meta-track-price");   // tracks current variant price

        // Helper: is the CURRENT variant the $85 tier?
        function isTwoForOneVariant() {
            if (!priceMeta) return false;

            // Use data attribute if set, fallback to text
            let priceText = priceMeta.getAttribute("data-product-price") || priceMeta.textContent || "";
            priceText = priceText.replace(/\s/g, ""); // remove spaces

            // Adjust this check if your currency formatting is different
            return priceText.includes("85");
            // e.g. "$85.00" or "85.00"
        }

        if (addToCartBtn && quantityInput && variantInput) {
            if (!document.querySelector(".buy-it-now-button")) {
                let buyNowBtn = document.createElement("button");
                buyNowBtn.textContent = "Buy It Now";
                buyNowBtn.classList.add("buy-it-now-button");
                buyNowBtn.setAttribute("type", "button");

                // 🔥 Add to Cart: force quantity = 2 when current price is $85
                addToCartBtn.onclick = function () {
                    if (isTwoForOneVariant()) {
                        quantityInput.value = 2;
                    }
                    // let Shopify's normal submit handler do the rest
                };

                // 🔥 Buy It Now: always use current variant + quantity, with 2-for-1 on $85
                buyNowBtn.onclick = function () {
                    const productVariantID = variantInput.value; // updated by Shopify when you change options
                    let quantity = parseInt(quantityInput.value) || 1;

                    if (isTwoForOneVariant()) {
                        quantity = 2;
                    }

                    const checkoutURL = `https://bootlegthebrand.com/cart/${productVariantID}:${quantity}`;
                    window.location.href = checkoutURL;
                };

                addToCartBtn.parentNode.insertBefore(buyNowBtn, addToCartBtn.nextSibling);
            }
        }
    }, 1000);
});
